module.exports = __webpack_public_path__ + "assets/img/37_1637_big.9bb0af14.jpg";